import { render, staticRenderFns } from "./CompanyDeleteTable.vue?vue&type=template&id=c5fdd604&scoped=true&"
import script from "./CompanyDeleteTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyDeleteTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDeleteTable.vue?vue&type=style&index=0&id=c5fdd604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fdd604",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
